import { InboxOutlined } from '@ant-design/icons';
import { Button, Form, Input, Progress, Upload, message } from 'antd';
import { useState } from 'react';
import { HiOutlineArrowLeft } from 'react-icons/hi';
import type { UploadFile } from 'antd/es/upload/interface';

import { InfoTooltip } from './InfoTooltip';
import {
  BackButton,
  FormBody,
  StepTitle,
  StepSubtitle,
  SubmitButton,
  UploadArea,
} from './styles';

const { Dragger } = Upload;

interface StepUploadFormProps {
  isSubmitting: boolean;
  uploadProgress: number;
  onSubmit: (file: File, description: string) => void;
  onBack: () => void;
}

export const StepUploadForm = ({ isSubmitting, uploadProgress, onSubmit, onBack }: StepUploadFormProps) => {
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState<UploadFile[]>([]);

  const handleFinish = (values: any) => {
    if (fileList.length === 0) {
      message.error('Por favor, selecione um arquivo antes de enviar.');
      return;
    }

    const file = fileList[0].originFileObj as File;
    onSubmit(file, values.description || '');
  };

  const handleBack = () => {
    if (fileList.length > 0 && !window.confirm('Você já selecionou um arquivo. Deseja voltar e perder a seleção?')) {
      return;
    }
    onBack();
  };

  return (
    <FormBody>
      <BackButton type="button" onClick={handleBack}>
        <HiOutlineArrowLeft />
        Voltar
      </BackButton>

      <StepTitle>Enviar Planilha</StepTitle>
      <StepSubtitle>
        Selecione o arquivo com os dados das notas fiscais. Aceitamos Excel (.xlsx, .xls) e CSV.
      </StepSubtitle>

      <Form
        form={form}
        layout="vertical"
        onFinish={handleFinish}
        requiredMark={false}
      >
        <UploadArea>
          <Dragger
            accept=".xlsx,.xls,.csv"
            maxCount={1}
            fileList={fileList}
            beforeUpload={() => false}
            onChange={(info) => {
              setFileList(info.fileList.slice(-1));
            }}
          >
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">
              Toque aqui para selecionar o arquivo
            </p>
            <p className="ant-upload-hint">
              Formatos: .xlsx, .xls ou .csv (tamanho máximo: 10MB)
            </p>
          </Dragger>
        </UploadArea>

        <Form.Item
          name="description"
          label={
            <span>
              Observações para o contador (opcional)
              <InfoTooltip text="Use este campo para informar algo relevante, como prazos ou detalhes específicos sobre os serviços." />
            </span>
          }
          style={{ marginTop: 28, marginBottom: 28 }}
        >
          <Input.TextArea
            rows={3}
            placeholder="Se quiser, escreva aqui alguma informação extra sobre esta solicitação..."
          />
        </Form.Item>

        <SubmitButton>
          <Button
            type="primary"
            htmlType="submit"
            loading={isSubmitting}
            block
            size="large"
            disabled={fileList.length === 0}
          >
            Enviar Solicitação
          </Button>
          {isSubmitting && uploadProgress > 0 && (
            <Progress
              percent={uploadProgress}
              size="small"
              status={uploadProgress < 100 ? 'active' : 'success'}
              style={{ marginTop: 16 }}
            />
          )}
        </SubmitButton>
      </Form>
    </FormBody>
  );
};
